<template>
  <router-view></router-view>
</template>

<script>
export default {
  beforeMount() {
    if (this.$route.meta.defaultChild) {
      this.$router.push(this.$route.path + "/" + this.$route.meta.defaultChild);
    }
  },
  beforeUpdate() {
    if (this.$route.meta.defaultChild) {
      this.$router.push(this.$route.path + "/" + this.$route.meta.defaultChild);
    }
  }
};
</script>


// WEBPACK FOOTER //
// App/Components/EmptyRouteView.vue